module.exports = {"231202001":"紫来","231202002":"爱路","231202003":"大有","231202004":"吉泰","231202005":"东兴","231202006":"北林","231202101":"宝山镇","231202102":"绥胜镇","231202103":"西长发镇","231202104":"永安镇","231202105":"太平川镇","231202106":"秦家镇","231202107":"双河镇","231202108":"三河镇","231202109":"四方台镇","231202110":"津河镇","231202111":"张维镇","231202113":"东津镇","231202114":"东富镇","231202201":"红旗乡","231202202":"连岗乡","231202203":"新华乡","231202204":"兴福乡","231202209":"三井乡","231202212":"五营乡","231202213":"兴和乡","231202579":"绥化局直"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231202.json
// module id = 732
// module chunks = 0